<template>
  <div class="reset-password">
    <FormLoginWrapper title="Reset Password">
      <q-input
        v-model="$v.email.$model"
        label="Email"
        type="email"
        autofocus
        v-bind="inputProps('email')"
        @keyup.enter="token ? resetPassword() : requestPasswordReset()"
      >
        <template v-slot:prepend>
          <q-icon v-bind="iconProps('fas fa-user-tie', $v.email.$error)" />
        </template>
      </q-input>

      <template v-if="token">
        <q-input
          v-model="$v.pass.$model"
          :type="showPass ? 'text' : 'password'"
          label="New password"
          v-bind="inputProps('pass')"
          @keyup.enter="token ? resetPassword() : requestPasswordReset()"
        >
          <template v-slot:prepend>
            <q-icon v-bind="iconProps('fas fa-lock-alt', $v.pass.$error)" />
          </template>

          <template v-slot:append>
            <q-icon
              v-bind="iconProps('', $v.pass.$error)"
              :class="showPass ? 'fas fa-eye' : 'fas fa-eye-slash'"
              class="cursor-pointer"
              @click="showPass = !showPass"
            />
          </template>
        </q-input>

        <q-input
          v-model="$v.passConfirm.$model"
          :type="showPassConfirm ? 'text' : 'password'"
          label="Confirm password"
          v-bind="inputProps('passConfirm')"
          @keyup.enter="token ? resetPassword() : requestPasswordReset()"
        >
          <template v-slot:prepend>
            <q-icon v-bind="iconProps('fas fa-lock-alt', $v.passConfirm.$error)" />
          </template>

          <template v-slot:append>
            <q-icon
              v-bind="iconProps('', $v.passConfirm.$error)"
              :class="showPassConfirm ? 'fas fa-eye' : 'fas fa-eye-slash'"
              class="cursor-pointer"
              @click="showPassConfirm = !showPassConfirm"
            />
          </template>
        </q-input>
      </template>

      <FormLoginLink text="Back to Login" @click="goToLogin" />

      <q-btn
        :loading="isRequestInProgress"
        rounded
        unelevated
        color="white"
        class="full-width q-mt-lg text-black"
        :label="token ? 'Reset Password' : 'Send'"
        @click="token ? resetPassword() : requestPasswordReset()"
      />
    </FormLoginWrapper>
  </div>
</template>

<script>
import commonProps from '@/reusable/login/commonProps'
import { validations } from './validations'
// Libraries
import { mapActions } from 'vuex'
// Components
import FormLoginWrapper from '@/reusable/login/FormLoginWrapper'
import FormLoginLink from '@/reusable/login/FormLoginLink'

export default {
  components: {
    FormLoginWrapper,
    FormLoginLink
  },

  mixins: [validations, commonProps],

  data: () => ({
    email: null,
    pass: null,
    passConfirm: null,
    showPass: false,
    showPassConfirm: false,
    isRequestInProgress: false
  }),

  computed: {
    token() {
      return this.$route.query.token
    },

    emailParam() {
      return this.$route.query.email
    }
  },

  created() {
    if (this.emailParam) this.email = this.emailParam
    this.inputProps = this.getCommonInputProps()
    this.iconProps = this.getCommonIconProps()
  },

  methods: {
    ...mapActions({
      apiToRequestPasswordReset: 'requestPasswordReset',
      apiToResetPassword: 'resetPassword'
    }),

    goToLogin() {
      this.$router.push('/login')
    },

    requestPasswordReset() {
      if (!this.$v_validationPass() || this.isRequestInProgress) return
      this.isRequestInProgress = true
      this.apiToRequestPasswordReset({ email: this.email }).finally(() => (this.isRequestInProgress = false))
    },

    resetPassword() {
      if (!this.$v_validationPass() || this.isRequestInProgress) return
      this.isRequestInProgress = true
      this.apiToResetPassword({
        token: this.token,
        email: this.email,
        password: this.pass,
        password_confirmation: this.passConfirm
      })
        .then(() => this.$router.push('/login'))
        .finally(() => (this.isRequestInProgress = false))
    }
  }
}
</script>

<style lang="stylus" scoped>
.reset-password {
  display flex
  justify-content center
  align-items center
  height 100vh
  background-image linear-gradient(135deg, rgba(155,225,171,0.85) 0%,rgba(0,123,255,0.85) 100%), url(../../assets/img/login/login-back.jpg)
  background-repeat no-repeat
  background-size cover
}
</style>
